/**
 * 项目配置文件
 */
// 项目根域名，注意需要带上'http'，以便共享session
export const webRoot = window.location.origin + "";
// 后端ajax域名
export const apiRoot =
  process.env.NODE_ENV === "development" ? "https://devepm3.netapitest.com" : window.location.origin;
// 后端socket域名
const socketUrls = {
  "testxnews.smgtech.net": "wss://testxnews-websocket.smgtech.net/wss",
  "testxnews2.smgtech.net": "wss://testxnews2-websocket.smgtech.net/wss",
  "zzb-xnews.smgtech.net": "wss://zzbxnews-websocket.smgtech.net/wss",
  "xnews.smgtech.net": "wss://xnews-websocket.smgtech.net/wss",
  "devradio.smgtech.net": "wss://devradio-websocket.smgtech.net/wss",
  "eradio.smgtech.net": "wss://eradio-websocket.smgtech.net/wss",
  "epm.smgtech.net": "wss://epm-websocket.smgtech.net/wss",
};

let _socketUrl = "";
_socketUrl = socketUrls[window.document.domain];

// _socketUrl = _socketUrl || socketUrls['testxnews.smgtech.net'] // 本地开发环境由于域名问题默认值需要手动切换
_socketUrl = _socketUrl || socketUrls["testxnews.smgtech.net"]; // 本地开发环境由于域名问题默认值需要手动切换

console.log(window.document.domain);
if (window.document.domain == "localhost") {
  _socketUrl = "wss://devepm5-websocket.netapitest.com/wss";
} else if (window.document.domain == "zzb-xnews.smgtech.net") {
  // console.log(123)
  _socketUrl = "wss://zzbxnews-websocket.smgtech.net/wss";
} else {
  let domain = window.document.domain;
  // let domain = 'testxnews.smgtech.net'
  domain = domain.split(".");
  domain[0] = domain[0] + "-websocket";
  domain = domain.join(".");
  _socketUrl = "wss://" + domain + "/wss";
  console.log(_socketUrl);
}

export const socketUrl = _socketUrl;
// 服务器验签
export const apiKey =
  apiRoot === "https://xnews.smgtech.net"
    ? "FdDcyRkPKGvDsOIixuwbRxDcVHXhKpzz"
    : "6ikPjmKemOxbAXJhCcvxDgrfZRWsRJ3g";
// 管理后台地址
export const adminPageUrl = window.location.origin + "/index.php?r=admin";
// baidu地图api地址
export const bdmap =
  "https://api.map.baidu.com/api?v=2.0&ak=epWoVCqlhofczATzUN0gl4UT&callback=";
// 上传文件js库地址
export const streamjs = "../static/stream-v1.js";
// WebSocket js地址
export const websocketjs = "../static/websocket.js";
// Aspera js 地址
export const asperajs = "../static/aspera.js";
// AW4 js 地址
export const aw4js = "../static/asperav4/asperaweb-4.min.js";
// AW4 config 地址
export const aw4config = "../static/asperav4/connectinstaller-4.min.js";
// jQuery js
export const jqjs = "../static/jquery.js";
// Aspera插件下载地址
// export const asperapage = 'http://10.27.137.83/web/base/asperav4/install.html'
export const asperapage =
  window.location.origin + "/static/asperav4/aspera.html";
// pe中间件
export const peMiddle = window.location.origin + "/static/pe/setup.exe";
// 加密js
export const encryptjs = "../static/encrypt.js";
// fabricjs
export const fabric = "../static/libs/fabric.js";
// tui-code-snippetjs
export const tuiCodeSnippet = "../static/libs/tui-code-snippet.js";
// FileSaverjs
export const FileSaver = "../static/libs/FileSaver.min.js";
// colorpickerjs
export const colorpicker = "../static/libs/colorpicker.min.js";
// tui-image-editorjs
export const tuiImageEditor = "../static/libs/tui-image-editor.min.js";
// cropperjs
export const cropper = "../static/libs/cropper.js";
// 加密公钥
export const encryptPublic =
  "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC8CIOtk2MZ0/YHQPFtgFevsNz+OdqwokmZFOgwMg8e8rIp7Hq5RIZDZFkvjGtqN9YDm3C+MTkxaORSoz5DKGIEvZY6F2P2Ey1xn9maUnHSNKryWWT1biqnSrGKVsy2RjDTF8eW4u+XvhV5R99fJ5BwephSWS9qEuCaS7SJxvtypQIDAQAB";
// 解密私钥
export const encryptPravite = "";
// api接口列表
export const apis = {
  // 文件to内网模块
  File_config: apiRoot + "/index.php?r=microservice/webapi/getuploadinfo",
  // 获取token
  File_get_token: "/v2/tk",
  // 获取文件已上传起点，上传文件
  File_post: "/v2/upload",
  // 取消文件
  File_cancel: apiRoot + "/index.php?r=upload/cancel",

  // 根据线索复制文件
  File_copy: apiRoot + "/index.php?r=file/webapi/copyfiles",
  // 添加多媒体文件，并关联稿件
  File_add: apiRoot + "/index.php?r=file/webapi/addfiles",
  // 选我的素材，并关联稿件
  File_bind: apiRoot + "/index.php?r=file/webapi/addto",
  // 获取文件状态
  File_status: apiRoot + "/index.php?r=file/webapi/getinfo",
  // 删除文件
  File_delete: apiRoot + "/index.php?r=file/webapi/del",
  // 重命名文件
  File_rename: apiRoot + "/index.php?r=file/webapi/rename",
  // 修改排序
  File_updatequickfilesort:
    apiRoot + "/index.php?r=file/webapi/updatequickfilesort",
  // 转文字接口
  File_convert: apiRoot + "/index.php?r=microservice/webapi/pickuptext",
  // 合成音频
  File_composite: apiRoot + "/index.php?r=microservice/webapi/makeupaudio",
  // 获取文字接口
  File_getWord: apiRoot + "/index.php?r=microservice/webapi/gettxt",
  // 错别字识别
  File_checkWord: apiRoot + "/index.php?r=microservice/webapi/cuo",
  // 导出TXT
  File_expTxt: apiRoot + "/index.php?r=microservice/webapi/exporttxt",
  // 多媒体文件下载
  File_download: apiRoot + "/index.php?r=microservice/webapi/downloadfile",
  // 音频合成回调
  File_composite_callback:
    apiRoot + "/index.php?r=microservice/webapi/makeupaudiohd",
  // 音频合成回调新
  File_composite_callbackhd:
    apiRoot + "/index.php?r=microservice/webapi/makeupaudio",
  // aspera及国内上传配置
  File_Aspera: apiRoot + "/index.php?r=file/webapi/uploadconfig",
  // 我的素材列表
  File_myFile: apiRoot + "/index.php?r=file/webapi/myfiles",
  // 素材添加标签
  File_addTag: apiRoot + "/index.php?r=file/webapi/addtag",
  // 删除素材标签
  File_delTag: apiRoot + "/index.php?r=file/webapi/deltag",
  // 删除我的素材
  File_delmyfile: apiRoot + "/index.php?r=file/webapi/delmyfile",
  // 素材推稿件
  File_filepush: apiRoot + "/index.php?r=file/webapi/filepush",
  // 添加快编素材
  File_addquickfile: apiRoot + "/index.php?r=file/webapi/addquickfile",
  // 快编素材列表
  File_quickfiles: apiRoot + "/index.php?r=file/webapi/quickfiles",

  // 用户模块
  // 用户菜单
  Usr_menu: apiRoot + "/index.php?r=crmcenter/get",
  // 更新用户信息
  Usr_update: apiRoot + "/index.php?r=crmcenter/updself",
  // 修改手机号发送验证码
  Usr_send: apiRoot + "/index.php?r=crmcenter/loginsend",
  // 重置密码
  Usr_reset_pwd: apiRoot + "/index.php?r=crmcenter/loginresetpassword",
  // 左侧菜单栏数据接口
  Site_menu: apiRoot + "/index.php?r=menu/getmenu",
  // 菜单栏小红点接口
  Site_menu_notify: apiRoot + "/index.php?r=menu/refresh",
  // 读取用户名片接口
  Usr_card: apiRoot + "/index.php?r=users/webapi/userinfo",
  // 网站标题接口
  Site_title: apiRoot + "/index.php?r=project/projectname",
  // 二维码接口
  User_qrcode: apiRoot + "/index.php?r=project/qrcode",
  // 媒资绑定
  Usr_linkmeizi: apiRoot + "/index.php?r=users/webapi/linkmeizi",
  // 媒资网登录token
  Usr_getlogintoken: apiRoot + "/index.php?r=users/webapi/getlogintoken",
  // CP媒资账号绑定
  Usr_bindcp: apiRoot + "/index.php?r=crmcenter/bind-cp",
  // CP媒资免登中间页
  Usr_fast_login_redirect: apiRoot + "/index.php?r=crmcenter/fast-login-redirect",
  // 首页全站检索
  Index_search: apiRoot + "/index.php?r=index/webapi/search",
  // 首页卡片
  Index_card: apiRoot + "/index.php?r=index/webapi/mainpage",

  // 登陆模块
  // 登录方式配置
  Log_loginMtds: apiRoot + "/index.php?r=loginlist/list",
  // 账号登录
  Log_account_login: apiRoot + "/index.php?r=crmcenter/login",
  // 发送验证码
  Log_send_verify: apiRoot + "/index.php?r=crmcenter/send",
  // 短信登录
  Log_phone_login: apiRoot + "/index.php?r=crmcenter/phonelogin",
  // 图形验证码（img）
  // Log_verify_img: verifyRoot + '/index.php?r=vcode/c',
  // 图形验证码（xhr）
  Log_verify_img: apiRoot + "/index.php?r=crmcenter/c",
  // 验证手机、验证码、短信
  Log_check_phone: apiRoot + "/index.php?r=crmcenter/valicode",
  // 重置密码
  Log_reset_pwd: apiRoot + "/index.php?r=crmcenter/resetpassword",
  // 登出
  Log_logout: apiRoot + "/index.php?r=crmcenter/logout",
  // 登录二维码
  Log_qrcode: apiRoot + "/index.php?r=crmcenter/qrcode-generate",
  // 二维码扫描状态
  Log_qrscan: apiRoot + "/index.php?r=crmcenter/qrcode-is-scanned",
  // 二维码登录
  Log_qrlogin: apiRoot + "/index.php?r=crmcenter/qrcode-is-enable-login",
  // 发送验证码
  Usr_sendVerify: apiRoot + "/index.php?r=crmcenter/loginsend",
  // 验证验证码
  Usr_checkVerufy: apiRoot + "/index.php?r=crmcenter/valcode",

  // 首页
  // 首页主接口
  Idx_main: apiRoot + "/index.php?r=index/webapi/index",

  // 公告
  // 公告详情
  announcement: apiRoot + "/index.php?r=index/webapi/detail",

  // 选题模块
  // 选题列表
  Tpc_list: apiRoot + "/index.php?r=topic/webapi/list",
  // 删除选题
  Tpc_delete: apiRoot + "/index.php?r=topic/webapi/delete",
  // 我的选题
  Tpc_my: apiRoot + "/index.php?r=topic/webapi/mylist",
  // 新建选题
  Tpc_new: apiRoot + "/index.php?r=topic/webapi/release",
  // 选题详情
  Tpc_detail: apiRoot + "/index.php?r=topic/webapi/detail",
  // 选题详情关联内容
  Tpc_detail_withs: apiRoot + "/index.php?r=topic/webapi/relatelist",
  // 列表关联内容
  Tpc_list_withs: apiRoot + "/index.php?r=topic/webapi/dropdownlist",

  // 采访模块
  // 采访库
  Itv_interviews: apiRoot + "/index.php?r=interview/webapi/list",
  // 采访详情
  Itv_interview_detail: apiRoot + "/index.php?r=interview/webapi/detail",
  // 采访审核列表
  Itv_check_interviews: apiRoot + "/index.php?r=interview/webapi/verifylist",
  // 采访审核操作
  Itv_handle_interviews: apiRoot + "/index.php?r=interview/webapi/verify",
  // 采访详情编辑
  Itv_detail_edit: apiRoot + "/index.php?r=interview/webapi/updatedetail",
  // 我的采访
  Itv_my: apiRoot + "/index.php?r=interview/webapi/myinterview",
  // 编辑采访
  Itv_interview_edit: apiRoot + "/index.php?r=interview/webapi/edit",
  // 新建采访
  Itv_interview_new: apiRoot + "/index.php?r=interview/webapi/edit",
  // 新建采访数据
  Itv_interview_new_data: apiRoot + "/index.php?r=interview/webapi/addviewdata",
  Itv_interview_addfiles: apiRoot + "/index.php?r=interview/webapi/addfiles",
  // 删除采访
  Itv_interview_del: apiRoot + "/index.php?r=interview/webapi/del",
  // 采访的一生
  Itv_interview_history:
    apiRoot + "/index.php?r=interview/webapi/interviewhistory",
  // 采访关联线索
  Itv_clues: apiRoot + "/index.php?r=interview/webapi/materials",
  // 采访关联选题
  Itv_topics: apiRoot + "/index.php?r=interview/webapi/topiclist",
  // 采访稿件锁
  Itv_lock: apiRoot + "/index.php?r=interview/webapi/lock",
  // 采访稿件解锁
  Itv_unlock: apiRoot + "/index.php?r=interview/webapi/unlock",
  // 采访撤回
  Itv_cancel: apiRoot + "/index.php?r=interview/webapi/cancel",
  // 跳转编辑前获取稿件状态
  Itv_check_status: apiRoot + "/index.php?r=interview/webapi/checkstatus",

  // 资源管理模块
  // 资源分配列表
  Res_resource_list: apiRoot + "/index.php?r=resource/webapi/demandlist",
  // 资源分配完成／退回
  Res_resource_handle: apiRoot + "/index.php?r=resource/webapi/finishdemand",
  // 添加人员／设备时，填充数据
  Res_resource_add_fill: apiRoot + "/index.php?r=resource/webapi/editinfo",
  // 分配资源
  Res_resource_set: apiRoot + "/index.php?r=resource/webapi/setresource",
  // 分配人员列表
  Res_roster_list: apiRoot + "/index.php?r=resource/webapi/getpersontype",
  // 添加临时人员
  Res_temporarypeople_add:
    apiRoot + "/index.php?r=resource/webapi/addtemporaryperson",
  // 修改资源管理任务的时间
  Res_modify_time: apiRoot + "/index.php?r=resource/webapi/settime",
  // 修改资源管理任务的备注
  Res_modify_remark: apiRoot + "/index.php?r=resource/webapi/setremark",

  // 设备
  // 设备列表
  Res_devicelist: apiRoot + "/index.php?r=resource/webapi/devicelist",
  // 设备任务列表
  Res_device_tasks: apiRoot + "/index.php?r=resource/webapi/devicetasks",
  // 设备启停
  Res_device_use: apiRoot + "/index.php?r=resource/webapi/modifydevice",
  // 取消设备任务
  Res_device_task_cancel:
    apiRoot + "/index.php?r=resource/webapi/canceldevicetask",
  // 添加设备
  Res_device_add: apiRoot + "/index.php?r=resource/webapi/adddevice",
  // 设备详情
  Res_device_detail: apiRoot + "/index.php?r=resource/webapi/devicedetail",
  // 更新设备详情
  Res_device_update: apiRoot + "/index.php?r=resource/webapi/updatedevice",
  // 设备出返记录
  Res_device_records: apiRoot + "/index.php?r=resource/webapi/devicelog",
  // 设备使用情况
  Res_device_uses: apiRoot + "/index.php?r=resource/webapi/deviceuselist",
  // 采访车列表
  Res_bus_list: apiRoot + "/index.php?r=resource/webapi/carlist",
  // 结束设备任务
  Res_device_task_finish:
    apiRoot + "/index.php?r=resource/webapi/finishdevicetask",
  // 设备外借
  Res_device_borrow: apiRoot + "/index.php?r=resource/webapi/borrowdevice",

  Edit_expand: apiRoot + "/index.php?r=resource/webapi/editexpand",

  Type_list: apiRoot + "/index.php?r=resource/webapi/typelist",

  Expand_list: apiRoot + "/index.php?r=resource/webapi/expandlist",

  optlogs: apiRoot + "/index.php?r=resource/webapi/optlogs",

  Expand_detail: apiRoot + "/index.php?r=resource/webapi/expanddetail",

  Expanduse: apiRoot + "/index.php?r=resource/webapi/expanduse",

  Task_log: apiRoot + "/index.php?r=resource/webapi/tasklog",

  Add_bug: apiRoot + "/index.php?r=resource/webapi/addbug",

  Bug_list: apiRoot + "/index.php?r=resource/webapi/buglist",

  Start_log: apiRoot + "/index.php?r=resource/webapi/startlog",

  Expand_demand: apiRoot + "/index.php?r=resource/webapi/expanddemand",

  Devicepopup: apiRoot + "/index.php?r=resource/webapi/devicepopup",

  Set_expand: apiRoot + "/index.php?r=resource/webapi/setexpand",

  Interview_receive: apiRoot + "/index.php?r=interview/webapi/receive",

  Return_list: apiRoot + "/index.php?r=interview/webapi/returnlist",

  Return_device: apiRoot + "/index.php?r=interview/webapi/returndevice",

  Delaylist: apiRoot + "/index.php?r=interview/webapi/delaylist",

  Interview_delay: apiRoot + "/index.php?r=interview/webapi/delay",

  Resource_returnlist: apiRoot + "/index.php?r=resource/webapi/returnlist",

  Delay_verify: apiRoot + "/index.php?r=interview/webapi/delayverify",

  Delay_pass: apiRoot + "/index.php?r=interview/webapi/delaypass",

  Return_device1: apiRoot + "/index.php?r=resource/webapi/returndevice",

  Return_optlog: apiRoot + "/index.php?r=resource/webapi/returnoptlog",

  Delay_data: apiRoot + "/index.php?r=resource/webapi/delaydata",

  Delay_users: apiRoot + "/index.php?r=resource/webapi/delayusers",

  Delay_userlist: apiRoot + "/index.php?r=resource/webapi/userdelaylist",

  Resource_upload: apiRoot + "/index.php?r=resource/webapi/upload",

  Resource_downloadexpand:
    apiRoot + "/index.php?r=resource/webapi/downloadexpand",

  Resource_delaydownload:
    apiRoot + "/index.php?r=resource/webapi/delaydownload",

  Resource_expanddownload:
    apiRoot + "/index.php?r=resource/webapi/expanddownload",

  Resource_downloadtemp: apiRoot + "/index.php?r=resource/webapi/downloadtemp",

  // 人员
  // 人员列表
  Res_people_list: apiRoot + "/index.php?r=resource/webapi/persons",
  // 人员休假列表
  Res_people_vacations: apiRoot + "/index.php?r=resource/webapi/restlist",
  // 人员休假
  Res_people_vacation_on: apiRoot + "/index.php?r=resource/webapi/addrest",
  // 人员完成休假
  Res_people_vacation_finish:
    apiRoot + "/index.php?r=resource/webapi/finishrest",
  // 人员取消休假
  Res_people_vacation_cancel:
    apiRoot + "/index.php?r=resource/webapi/cancelrest",
  // 编辑人员
  Res_people_update: apiRoot + "/index.php?r=resource/webapi/updateperson",
  // 添加人员
  Res_people_add: apiRoot + "/index.php?r=resource/webapi/addperson",
  // 删除人员
  Res_people_del: apiRoot + "/index.php?r=resource/webapi/delperson",
  // 人员详情
  Res_people_detail: apiRoot + "/index.php?r=resource/webapi/persondetail",
  // 人员分配记录
  Res_people_records: apiRoot + "/index.php?r=resource/webapi/personiview",
  // 人员关联休假
  Res_people_rest: apiRoot + "/index.php?r=resource/webapi/personrestlist",

  /*************************************************************** */
  //办公提案
  proposalLibrary: apiRoot + "/index.php?r=proposal/webapi/list",
  //提案导出
  proposalExport: apiRoot + "/index.php?r=proposal/webapi/output",
  //我的提案
  myProposal: apiRoot + "/index.php?r=proposal/webapi/myproposal",
  //创建提案
  creatProposal: apiRoot + "/index.php?r=proposal/webapi/add",
  //提案详情
  proposalDetail: apiRoot + "/index.php?r=proposal/webapi/detail",

  //线索过滤条件列表
  clueFilters: apiRoot + "/index.php?r=material/webapi/getlistsearch",
  // 获取订阅关键字列表
  clueKeywords: apiRoot + "/index.php?r=material/webapi/subscribelist",
  // 保存新增关键字
  clueSaveKeyword: apiRoot + "/index.php?r=material/webapi/savesubscribe",
  //互联网线索库
  internetClue: apiRoot + "/index.php?r=material/webapi/internetmaterial",
  //渠道线索
  channelClue: apiRoot + "/index.php?r=material/webapi/channelmaterial",
  //自采线索
  selfClue: apiRoot + "/index.php?r=material/webapi/selfminingmaterial",
  //收录线索
  includedClue: apiRoot + "/index.php?r=material/webapi/includematerial",
  //我的线索
  myClue: apiRoot + "/index.php?r=material/webapi/mymaterial",
  // 线索过滤条件一级列表
  clueFilterSources: apiRoot + "/index.php?r=material/webapi/getsources",
  // 线索一级信源设置
  clueFiltersSourcesSet: apiRoot + "/index.php?r=material/webapi/savesource",
  // 线索详情
  clueDetail: apiRoot + "/index.php?r=material/webapi/detail",
  // 线索新建、编辑初始化数据
  clueInit: apiRoot + "/index.php?r=material/webapi/editinfo",
  // 新建／编辑线索
  editClue: apiRoot + "/index.php?r=material/webapi/edit",
  // 发布线索
  uploadClue: apiRoot + "/index.php?r=material/webapi/upload",
  // 删除线索
  deleteClue: apiRoot + "/index.php?r=material/webapi/del",
  // 导出线索
  download_clue: apiRoot + "/index.php?r=material/webapi/download",
  // 线索历史版本号
  clue_versions: apiRoot + "/index.php?r=material/webapi/histroylist",
  // 线索历史版本详情
  clue_history: apiRoot + "/index.php?r=material/webapi/historydetail",
  // 线索关联选题
  clue_topics: apiRoot + "/index.php?r=material/webapi/topiclist",
  // 线索关联采访
  clue_interviews: apiRoot + "/index.php?r=material/webapi/interviewlist",
  // 自动保存线索
  clue_autosave: apiRoot + "/index.php?r=material/webapi/autosave",
  // 线索to快编
  clue_toEdit: apiRoot + "/index.php?r=material/webapi/pushtoquickedit",
  // 线索稿件锁
  clue_lock: apiRoot + "/index.php?r=material/webapi/lock",
  // 线索稿件解锁
  clue_unlock: apiRoot + "/index.php?r=material/webapi/unlock",
  // 线索弹窗详情
  clue_notifyDetail: apiRoot + "/index.php?r=material/webapi/materialpopup",
  // 线索弹窗弹出权限
  clue_notifyAuth: apiRoot + "/index.php?r=material/webapi/popupshow",
  // 线索推报道
  clue_toReport: apiRoot + "/index.php?r=material/webapi/pushtoreport",
  // 线索收录单
  clue_includes: apiRoot + "/index.php?r=material/webapi/includelist",
  // 通用线索列表
  clue_common: apiRoot + "/index.php?r=material/webapi/clues",

  //报道库
  reportLibrary: apiRoot + "/index.php?r=report/webapi/list",
  //新建报道
  creatReport: apiRoot + "/index.php?r=report/webapi/add",
  //报道创建、编辑头部部门、平台
  creatReportGlobal: apiRoot + "/index.php?r=report/webapi/editinfo",
  // 获取AI编辑器(AIGraphicEditor/Scube)签名
  getScubeSign: apiRoot + "/index.php?r=content/users/get-scube-sign",
  //我的报道
  myreport: apiRoot + "/index.php?r=report/webapi/myreport",
  //报道详情
  reportDetail: apiRoot + "/index.php?r=report/webapi/detail",
  // 报道审核列表
  checkReport: apiRoot + "/index.php?r=report/webapi/verifylist",
  // 通过／退回报道
  Rpt_handle_report: apiRoot + "/index.php?r=report/webapi/verify",
  // 报道的一生
  Rpt_life: apiRoot + "/index.php?r=report/webapi/reportlife",
  // 新建／编辑报道
  saveReport: apiRoot + "/index.php?r=report/webapi/edit",
  // 删除报道
  deleteReport: apiRoot + "/index.php?r=report/webapi/del",
  // 发送至
  pushTo: apiRoot + "/index.php?r=report/webapi/pushto",
  // 送看看
  toKK: apiRoot + "/index.php?r=report/webapi/pushtokankan",
  // 关联线索
  withClue: apiRoot + "/index.php?r=report/webapi/materiallist",
  // 审核人列表
  checker_list: apiRoot + "/index.php?r=report/webapi/verifyusers",
  // 添加审核人
  checker_add: apiRoot + "/index.php?r=report/webapi/addverify",
  // 下载报道
  down_report: apiRoot + "/index.php?r=report/webapi/download",
  // 报道历史版本
  Rpt_versions: apiRoot + "/index.php?r=report/webapi/historylist",
  // 历史版本详情
  Rpt_history: apiRoot + "/index.php?r=report/webapi/historydetail",
  // 发布报道
  Rpt_release: apiRoot + "/index.php?r=report/webapi/release",
  // 关联选题
  Rpt_topics: apiRoot + "/index.php?r=report/webapi/topiclist",
  // 关联采访
  Rpt_interviews: apiRoot + "/index.php?r=report/webapi/interviewlist",
  // 发送至弹窗数据
  Rpt_pushlist: apiRoot + "/index.php?r=report/webapi/pushlist",
  // 报道to快编
  Rpt_toEdit: apiRoot + "/index.php?r=report/webapi/pushtoquickedit",
  // 报道浏览数量
  Rpt_viewnum: apiRoot + "/index.php?r=report/webapi/kankanviewnum",
  // 报道稿件锁
  Rpt_lock: apiRoot + "/index.php?r=report/webapi/lock",
  // 报道稿件解锁
  Rpt_unlock: apiRoot + "/index.php?r=report/webapi/unlock",
  // 复制报道
  Rpt_copy: apiRoot + "/index.php?r=report/webapi/copy",
  // 稿件类型
  Rpt_typelist: apiRoot + "/index.php?r=report/webapi/typelist",
  // 看看列表
  kankanList: apiRoot + "/index.php?r=report/webapi/kankanlist",
  //考评打分
  evaluatingList: apiRoot + "/index.php?r=appraisal/webapi/list",
  //打分
  evaluatingSetscore: apiRoot + "/index.php?r=appraisal/webapi/setscore",
  //保存打分
  evaluatingsave: apiRoot + "/index.php?r=appraisal/webapi/save",
  //统计
  evaluatingCountList: apiRoot + "/index.php?r=appraisal/webapi/statistics",
  // 栏目考评
  sectionEvaluation: apiRoot + "/index.php?r=appraisal/webapi/columnlist",
  // 栏目考评打分
  sectionEvaluationScore: apiRoot + "/index.php?r=appraisal/webapi/edit",
  // 栏目考评打印
  sectionEvaluationPrint: apiRoot + "/index.php?r=appraisal/webapi/printres",
  // 栏目考评导出
  sectionEvaluationExport:
    apiRoot + "/index.php?r=appraisal/webapi/columndownload",
  // 部门考评
  departEvaluation: apiRoot + "/index.php?r=appraisal/webapi/departcolumn",
  // 部门统计
  departStatic: apiRoot + "/index.php?r=appraisal/webapi/departlist",
  // 个人统计
  personStatic: apiRoot + "/index.php?r=appraisal/webapi/userlist",
  // 部门统计导出
  departStaticExport: apiRoot + "/index.php?r=appraisal/webapi/departdownload",
  // 个人统计导出
  personStaticExport: apiRoot + "/index.php?r=appraisal/webapi/userdownload",
  // 串联单详情页
  tandemDetail: apiRoot + "/index.php?r=appraisal/webapi/detail",

  // 帮助中心
  // 帮助菜单
  help_menu: apiRoot + "/index.php?r=help/webapi/menus",
  // 帮助详情
  help_detail: apiRoot + "/index.php?r=help/webapi/detail",

  // 数据中心
  // 看看发布
  data_kankan: apiRoot + "/index.php?r=kankan/webapi/kankanrelease",
  // 导出看看表格
  data_kankan_expt: apiRoot + "/index.php?r=kankan/webapi/download",
  // 电视报片
  data_tv: apiRoot + "/index.php?r=kankan/webapi/tvbaopian",
  // 电视报片详情
  data_tv_detail: apiRoot + "/index.php?r=kankan/webapi/baopiandetail",

  // 素材文件
  // 文件列表
  file_list: apiRoot + "/index.php?r=file/webapi/audiomaterials",
  // 文件详情
  file_detail: apiRoot + "/index.php?r=file/webapi/detail",
  // 文件素材推报道
  file_toReport: apiRoot + "/index.php?r=file/webapi/pushtoreport",
  // 文件素材重新识别
  file_recode: apiRoot + "/index.php?r=file/webapi/kbtrans",

  //发布库
  publishLibrary: apiRoot + "/index.php?r=publish/webapi/list",
  //发布库复制
  Publish_copy: apiRoot + "/index.php?r=publish/webapi/copy",
  // 我的发布
  mypublish: apiRoot + "/index.php?r=publish/webapi/mypublish",
  //我的发布   发布按钮
  Rpb_release: apiRoot + "/index.php?r=publish/webapi/release",
  //我的发布   删除按钮
  deletePublish: apiRoot + "/index.php?r=publish/webapi/del",
  //发布审核列表
  publishVerifylist: apiRoot + "/index.php?r=publish/webapi/verifylist",
  //发布审核 通过退回
  publishVerify: apiRoot + "/index.php?r=publish/webapi/verify",
  //发布-送审
  publishAddverify: apiRoot + "/index.php?r=publish/webapi/addverify",
  // 发布编辑详情
  publish_editinfo: apiRoot + "/index.php?r=publish/webapi/editinfo",
  // 发布详情
  publish_detail: apiRoot + "/index.php?r=publish/webapi/detail",
  // 下载发布
  down_publish: apiRoot + "/index.php?r=publish/webapi/download",
  // 发布的一生
  publish_life: apiRoot + "/index.php?r=publish/webapi/publishlife",
  // 发布历史版本
  publish_history: apiRoot + "/index.php?r=publish/webapi/historylist",
  // 发布历史版本详情
  publish_historydetail: apiRoot + "/index.php?r=publish/webapi/historydetail",
  // 发布关联报道
  publish_withReport: apiRoot + "/index.php?r=publish/webapi/reportlist",
  // 发布关联选题
  publish_withTopic: apiRoot + "/index.php?r=publish/webapi/topiclist",
  // 发布关联采访
  publish_withInterview: apiRoot + "/index.php?r=publish/webapi/interviewlist",
  // 发布发布
  publish_publish: apiRoot + "/index.php?r=publish/webapi/release",
  // 发布关联线索
  publish_withClue: "/index.php?r=publish/webapi/materiallist",
  // 编辑发布
  publish_edit: "/index.php?r=publish/webapi/edit",
  // 发布稿件锁
  publish_lock: "/index.php?r=publish/webapi/lock",
  // 发布稿件解锁
  publish_unlock: "/index.php?r=publish/webapi/unlock",
  // 复制线索文件到发布
  publish_withClueFile: "/index.php?r=file/webapi/publishcopy",
  // 推送发布
  publish_pushPublish: "/index.php?r=publish/webapi/pushtopublish",
  // 获取音频编辑模式配置
  editaudioconfig: "/index.php?r=microservice/webapi/editaudioconfig",
  // 获取音频剪辑信息
  editaudioinfo: "/index.php?r=file/webapi/audioinfo",
  // 提交音频剪辑
  editaudio: "/index.php?r=microservice/webapi/editaudio",
  // 获取推送平台
  publish_platform: "/index.php?r=publish/webapi/platform",
  // 微服务，抓取微信图片
  grabwximg: "/index.php?r=microservice/webapi/grabwximg",

  // 内容拆分标签
  split_words: "/index.php?r=microservice/webapi/get-participle",
  // 图片剪辑上传
  editimg: "/index.php?r=microservice/webapi/editimg",
  // 提交视频技审
  videoAudit: apiRoot + "/index.php?r=microservice/webapi/audit",
  // 视频人脸识别
  faceRec: apiRoot + "/index.php?r=microservice/webapi/facerec",
  // 视频人脸识别结果
  faceRes: apiRoot + "/index.php?r=microservice/webapi/faceres",
  // 照片人脸识别结果
  imgface: apiRoot + "/index.php?r=microservice/webapi/imgface",
  // 消息中心列表
  msglist: apiRoot + "/index.php?r=microservice/webapi/msglist",
  // 查看消息
  readmsg: apiRoot + "/index.php?r=microservice/webapi/readmsg",
  // 设置文件简介
  setInfoMaterial: apiRoot + "/index.php?r=file/webapi/setinfo",
  // 删除快编素材
  delQuickEdit: apiRoot + "/index.php?r=file/webapi/delquickfile",

  // 视频剪辑项目列表
  editvideoList: apiRoot + "/index.php?r=editvideo/webapi/index",
  // 新增视频剪辑项目
  editvideoInsert: apiRoot + "/index.php?r=editvideo/webapi/insert",
  // 删除视频剪辑项目
  deletevideoInsert: apiRoot + "/index.php?r=editvideo/webapi/delete",
  // 复制视频剪辑项目
  copyvideoInsert: apiRoot + "/index.php?r=editvideo/webapi/copy",
  // 一键合成
  oneCompose: apiRoot + "/index.php?r=editvideo/webapi/compose",

  // 其他
  // 添加警示
  warn_add: apiRoot + "/index.php?r=warning/webapi/add",

  // 公共串联单列表
  series_list: apiRoot + "/index.php?r=series/webapi/index",
  // 公共串联单列表
  series_detail: apiRoot + "/index.php?r=series/webapi/info",
  // 体育串联单-串联单列表
  sport_series_program_list: apiRoot + "/index.php?r=programSeries/webapi/search-program-series",
  // 体育串联单-文稿列表
  sport_series_list: apiRoot + "/index.php?r=programSeries/webapi/search-series",
  // 体育串联单栏目下拉
  sport_series_column_list: apiRoot + "/index.php?r=programSeries/webapi/get-column-list",
  // 关键词
  taglist: apiRoot + "/index.php?r=microservice/webapi/taglist",
  // version
  version: apiRoot + "/index.php?r=version/pc",
  // 复制
  materialCopy: apiRoot + "/index.php?r=file/webapi/copyurl",
  // 素材关联稿件
  fileContent: apiRoot + "/index.php?r=file/webapi/contents",
  // 设置视频封面图
  setcover: apiRoot + "/index.php?r=file/webapi/setcover",
  // 清除所以消息
  clearmsg: apiRoot + "/index.php?r=microservice/webapi/clearmsg",
  // 流媒体媒资列表
  streammediaList: apiRoot + "/index.php?r=streammedia/webapi/list",
  // 流媒体媒资下载
  streammediaDownload: apiRoot + "/index.php?r=streammedia/webapi/download",
  // 流媒体媒资关键字
  streammediaKeywords: apiRoot + "/index.php?r=streammedia/webapi/keywords",
  // 删除流媒体媒资关键字
  delStreammediaKeywords:
    apiRoot + "/index.php?r=streammedia/webapi/delkeywords",
  // 流媒体媒资详情
  streammediaDetail: apiRoot + "/index.php?r=streammedia/webapi/detail",
  // 流媒体媒资回调
  streammediaCallback: apiRoot + "/index.php?r=streammedia/webapi/callback",
  // 流媒体媒资文章
  streammediaContents: apiRoot + "/index.php?r=streammedia/webapi/contents",
  // 文件分享
  fileShare: apiRoot + "/index.php?r=file/webapi/share",
  // 文件分享权限
  fileCheck: apiRoot + "/index.php?r=share/check",
  // 文件分享详情
  fileDetail: apiRoot + "/index.php?r=share/detail",
  // 新媒体平台列表
  newMediaPlatform: apiRoot + "/index.php?r=newmedia/webapi/platforms",
  // 新媒体平台审核开关
  newMediaPlatformSetverify: apiRoot + "/index.php?r=newmedia/webapi/setverify",
  // 新媒体平台用户列表
  newMediaPlatformUserList: apiRoot + "/index.php?r=newmedia/webapi/userlist",
  // 新媒体平台用户列表
  newMediaPlatformUser: apiRoot + "/index.php?r=newmedia/webapi/platformusers",
  // 新媒体平台创建
  newMediaPlatformCreate: apiRoot + "/index.php?r=newmedia/webapi/create",
  // 新媒体平台信息
  newMediaPlatformInfo: apiRoot + "/index.php?r=newmedia/webapi/editinfo",
  // 新媒体平台设置用户
  newMediaPlatformSetUsers: apiRoot + "/index.php?r=newmedia/webapi/setusers",
  // 新媒体平台稿件编辑
  newMediaPlatformEdit: apiRoot + "/index.php?r=newmedia/webapi/edit",
  // 新媒体平台视频打标保存标签
  newMediaPlatformSaveLabel: apiRoot + "/index.php?r=newmedia/webapi/save-label",
  // 新媒体平台设置封面
  newMediaPlatformSetCover: apiRoot + "/index.php?r=newmedia/webapi/setcover",
  // 新媒体平台发布
  newMediaPlatformRelease: apiRoot + "/index.php?r=newmedia/webapi/release",

  newMediaPlatformReleasecheck:
    apiRoot + "/index.php?r=newmedia/webapi/releasecheck",
  // 新媒体平台分享
  newMediaPlatformShare: apiRoot + "/index.php?r=newmedia/webapi/share",
  // 新媒体平台发布库
  newMediaPlatformList: apiRoot + "/index.php?r=newmedia/webapi/list",
  // 新媒体平台我的发布
  newMediaPlatformMyList: apiRoot + "/index.php?r=newmedia/webapi/mylist",
  // 新媒体平台稿件节点记录
  newMediaPlatformMyHistory: apiRoot + "/index.php?r=newmedia/webapi/history",
  // 新媒体平台稿件详情
  newMediaPlatformMyDetail: apiRoot + "/index.php?r=newmedia/webapi/detail",
  // 新媒体平台稿件转发
  newMediaPlatformMyCopy: apiRoot + "/index.php?r=newmedia/webapi/copy",
  // 新媒体平台稿件重新发布
  newMediaPlatformMyResend: apiRoot + "/index.php?r=newmedia/webapi/resend",
  // 新媒体平台稿件删除
  newMediaPlatformMyDel: apiRoot + "/index.php?r=newmedia/webapi/del",
  // 新媒体平台稿件分享详情
  newMediaPlatformShareDetail: apiRoot + "/index.php?r=share/newmedia",
  // 新媒体平台删除
  newMediaPlatformDelcolumn: apiRoot + "/index.php?r=newmedia/webapi/delcolumn",
  // 新媒体平台更新封面
  newMediaPlatformGetCover: apiRoot + "/index.php?r=newmedia/webapi/getcover",
  // 新媒体平台绑定b+
  newMediaPlatformSubmitAccount:
    apiRoot + "/index.php?r=newmedia/webapi/submitaccount",
  // 新媒体平台b+标签
  newMediaPlatformtags: apiRoot + "/index.php?r=newmedia/webapi/tags",
  // 新媒体平台保存标签
  newMediaPlatformSaveTags: apiRoot + "/index.php?r=newmedia/webapi/savetags",
  // 虚拟主播列表
  anchorList: apiRoot + "/index.php?r=anchor/webapi/list",
  // 虚拟主播详情
  anchorDetail: apiRoot + "/index.php?r=anchor/webapi/detail",
  // 主播音频列表
  anchorVoices: apiRoot + "/index.php?r=anchor/webapi/voices",
  // 动作列表
  anchorMoves: apiRoot + "/index.php?r=anchor/webapi/moves",
  // 提交合成
  anchorSubmit: apiRoot + "/index.php?r=anchor/webapi/submit",
  // 提交创建
  anchorCreate: apiRoot + "/index.php?r=anchor/webapi/create",
  // 提交创建
  anchorAudioDetail: apiRoot + "/index.php?r=anchor/webapi/audiodetail",
  // 抖音
  getDyUrl: apiRoot + "/index.php?r=newmedia/webapi/getdyurl",
  // 下载文稿
  newMediaDownload: apiRoot + "/index.php?r=newmedia/webapi/download",
  // 发布审核列表
  newMediaVerifylist: apiRoot + "/index.php?r=newmedia/webapi/verifylist",
  // 发布审核流程
  newMediaCheckProcess: apiRoot + "/index.php?r=newmedia/webapi/checkprocess",
  // 新媒体发布锁
  newMediaLock: apiRoot + "/index.php?r=newmedia/webapi/lock",
  // 新媒体发布撤回
  newMediaCancel: apiRoot + "/index.php?r=newmedia/webapi/cancel",
  // 新媒体发布查稿件状态
  newMediaCheckstatus: apiRoot + "/index.php?r=newmedia/webapi/checkstatus",
  // 新媒体发布审核
  newMediaVerify: apiRoot + "/index.php?r=newmedia/webapi/verify",
  // 新媒体发布审核记录
  newMediaVerifyLog: apiRoot + "/index.php?r=newmedia/webapi/verifylog",
  // 栏目流程
  newMediaProcess: apiRoot + "/index.php?r=newmedia/webapi/process",
  // 栏目流程提交
  newMediaSubmitprocess: apiRoot + "/index.php?r=newmedia/webapi/submitprocess",
  // 水印
  imglogos: apiRoot + "/index.php?r=newmedia/webapi/imglogos",
  // 水印
  addwatermark: apiRoot + "/index.php?r=newmedia/webapi/addwatermark",
  // 人工回调
  streamMediaSend: apiRoot + "/index.php?r=streammedia/webapi/send",
  // 客户端列表
  clients: apiRoot + "/index.php?r=sentiment/webapi/clients",
  // 用户客户端列表
  userclient: apiRoot + "/index.php?r=sentiment/webapi/userclient",
  // 保存客户端
  saveclient: apiRoot + "/index.php?r=sentiment/webapi/saveclient",
  // 客户端新闻列表
  clientnews: apiRoot + "/index.php?r=sentiment/webapi/clientnews",
  // 用户媒体看板列表
  sentimentboards: apiRoot + "/index.php?r=sentiment/webapi/boards",
  // 删除媒体看板
  delboard: apiRoot + "/index.php?r=sentiment/webapi/delboard",
  // 新闻详情
  newsdetail: apiRoot + "/index.php?r=sentiment/webapi/newsdetail",
  // 新建媒体看板
  editboard: apiRoot + "/index.php?r=sentiment/webapi/editboard",
  // 看板详情
  boardinfo: apiRoot + "/index.php?r=sentiment/webapi/boardinfo",
  // 设置媒体看板顺序
  setsort: apiRoot + "/index.php?r=sentiment/webapi/setsort",
  // 媒体看板媒体列表
  medias: apiRoot + "/index.php?r=sentiment/webapi/medias",
  // 媒体看板新闻列表
  sentimentnews: apiRoot + "/index.php?r=sentiment/webapi/news",
  // 看板文稿详情
  boardcontent: apiRoot + "/index.php?r=sentiment/webapi/boardcontent",
  // 看板视频详情
  boardvideo: apiRoot + "/index.php?r=sentiment/webapi/boardvideo",
  // 文稿追踪提交
  track: apiRoot + "/index.php?r=sentiment/webapi/track",
  // 文稿追踪发布来源
  typelist: apiRoot + "/index.php?r=sentiment/webapi/typelist",
  // 文稿追踪列表
  tracklist: apiRoot + "/index.php?r=sentiment/webapi/tracklist",
  // 文稿追踪列表清空
  tracklistclear: apiRoot + "/index.php?r=sentiment/webapi/clear",
  // 文稿追踪详情
  trackdetail: apiRoot + "/index.php?r=sentiment/webapi/trackdetail",
  // 文稿追踪详情
  analysissearch: apiRoot + "/index.php?r=sentiment/webapi/search",
  // 浏览器提醒设置
  browsernotice: apiRoot + "/index.php?r=sentiment/webapi/browsernotice",
  // 浏览器消息
  browsermsg: apiRoot + "/index.php?r=sentiment/webapi/msg",
  // 舆情下载
  browserdownload: apiRoot + "/index.php?r=sentiment/webapi/download",
  // 内容传播力分析详情
  analysisDetail: apiRoot + "/index.php?r=sentiment/webapi/searchdetail",
  // 内容传播力分析详情图标
  cas: apiRoot + "/index.php?r=sentiment/webapi/searchcas",
  // 文稿追踪详情图标
  trackcas: apiRoot + "/index.php?r=sentiment/webapi/trackcas",
  // 文稿追踪导出
  searchexport: apiRoot + "/index.php?r=sentiment/webapi/searchexport",

  trackSelect: apiRoot + "/index.php?r=sentiment/webapi/trackselect",

  senHasNew: apiRoot + "/index.php?r=sentiment/webapi/hasnew",

  fileTags: apiRoot + "/index.php?r=file/webapi/tags",

  tagformat: apiRoot + "/index.php?r=file/webapi/tagformat",

  addtagnew: apiRoot + "/index.php?r=file/webapi/addtagnew",

  deltagnew: apiRoot + "/index.php?r=file/webapi/deltagnew",

  inteltag: apiRoot + "/index.php?r=microservice/webapi/inteltag",

  timevideolist: apiRoot + "/index.php?r=timevideo/webapi/list",

  timevideoprograms: apiRoot + "/index.php?r=timevideo/webapi/programs",

  // 专题追踪
  sentimentThemes: apiRoot + "/index.php?r=sentiment/webapi/themes",

  sentimentThemeinfo: apiRoot + "/index.php?r=sentiment/webapi/themeinfo",

  sentimentEdittheme: apiRoot + "/index.php?r=sentiment/webapi/edittheme",

  sentimentResend: apiRoot + "/index.php?r=sentiment/webapi/resend",

  sentimentReupdate: apiRoot + "/index.php?r=sentiment/webapi/reupdate",

  sentimentDel: apiRoot + "/index.php?r=sentiment/webapi/del",

  sentimentPreview: apiRoot + "/index.php?r=sentiment/webapi/preview",

  sentimentDownloaddata: apiRoot + "/index.php?r=sentiment/webapi/downloaddata",

  sentimentThemedetail: apiRoot + "/index.php?r=sentiment/webapi/themedetail",

  sentimentRanks: apiRoot + "/index.php?r=sentiment/webapi/ranks",

  sentimentRankdetail: apiRoot + "/index.php?r=sentiment/webapi/rankdetail",

  pushinglist: apiRoot + "/index.php?r=newmedia/webapi/pushinglist",

  downloadexecl: apiRoot + "/index.php?r=sentiment/webapi/downloadexecl",

  rankvideo: apiRoot + "/index.php?r=sentiment/webapi/rankvideo",

  rankdetail: apiRoot + "/index.php?r=sentiment/webapi/rankdetail",

  downloadreport: apiRoot + "/index.php?r=sentiment/webapi/downloadreport",

  knewstranscode: apiRoot + "/index.php?r=newmedia/webapi/knewstranscode",

  getRelativeSystems: apiRoot + "/index.php?r=crmcenter/get-relative-systems",

  getRedirectSystems: apiRoot + "/index.php?r=crmcenter/get-redirect-systems",

  redirectThird: apiRoot + "/index.php?r=crmcenter/redirect-third",

  dataCenterRedirect: apiRoot + "/index.php?r=datacenter/index/redirect",

  previewurl: apiRoot + "/index.php?r=newmedia/webapi/previewurl",

  setposter: apiRoot + "/index.php?r=newmedia/webapi/setposter",

  getdypushurl: apiRoot + "/index.php?r=newmedia/webapi/getdypushurl",

  dyhistory: apiRoot + "/index.php?r=newmedia/webapi/dyhistory",

  downloadplatformusers:
    apiRoot + "/index.php?r=newmedia/webapi/downloadplatformusers",

  copylist: apiRoot + "/index.php?r=newmedia/webapi/copylist",

  copyto: apiRoot + "/index.php?r=file/webapi/copyto",

  dytranscode: apiRoot + "/index.php?r=newmedia/webapi/dytranscode",

  delposter: apiRoot + "/index.php?r=newmedia/webapi/delposter",

  getPickUpList: apiRoot + "/index.php?r=microservice/webapi/get-pickup-list",

  deletePickUp: apiRoot + "/index.php?r=microservice/webapi/delete-pickup",

  getEditAudioList:
    apiRoot + "/index.php?r=microservice/webapi/get-edit-audio-list",

  deleteEditAudio:
    apiRoot + "/index.php?r=microservice/webapi/delete-edit-audio",

  getExpanddeviceByDeviceid:
    apiRoot + "/index.php?r=interview/webapi/get-expand-device-by-deviceid",

  verifyTemplateList:
    apiRoot + "/index.php?r=newmedia/webapi/verify-template-list",

  saveVerifyTemplate:
    apiRoot + "/index.php?r=newmedia/webapi/save-verify-template",

  saveVerify: apiRoot + "/index.php?r=newmedia/webapi/save-verify",

  setMinVerifyNum: apiRoot + "/index.php?r=newmedia/webapi/set-min-verify-num",

  getVerifyTemplate:
    apiRoot + "/index.php?r=newmedia/webapi/get-verify-template",

  setVerifyTitle: apiRoot + "/index.php?r=newmedia/webapi/set-verify-title",

  delVerifyTemplate:
    apiRoot + "/index.php?r=newmedia/webapi/del-verify-template",

  getVerifyMinCount:
    apiRoot + "/index.php?r=newmedia/webapi/get-verify-min-count",

  adminverifyTemplateList:
    apiRoot + "/index.php?r=admin/newmedia/verify-template-list",

  adminsaveVerifyTemplate:
    apiRoot + "/index.php?r=admin/newmedia/save-verify-template",

  adminsaveVerify: apiRoot + "/index.php?r=admin/newmedia/save-verify",

  adminsetMinVerifyNum:
    apiRoot + "/index.php?r=admin/newmedia/set-min-verify-num",

  admingetVerifyTemplate:
    apiRoot + "/index.php?r=admin/newmedia/get-verify-template",

  adminsetVerifyTitle: apiRoot + "/index.php?r=admin/newmedia/set-verify-title",

  admindelVerifyTemplate:
    apiRoot + "/index.php?r=admin/newmedia/del-verify-template",

  admingetVerifyMinCount:
    apiRoot + "/index.php?r=admin/newmedia/get-verify-min-count",

  checkPassAccess: apiRoot + "/index.php?r=newmedia/webapi/check-pass-access",

  admintranscodeengine: apiRoot + "/index.php?r=admin/params/transcodeengine",

  admintranscodesubmit: apiRoot + "/index.php?r=admin/params/transcodesubmit",

  getDataInfo: apiRoot + "/index.php?r=datacenter/index/get-data-info",

  getMakeupAudioList:
    apiRoot + "/index.php?r=microservice/webapi/get-makeup-audio-list",

  makeupAudioDetail:
    apiRoot + "/index.php?r=microservice/webapi/makeup-audio-detail",

  makeupAudioDelete:
    apiRoot + "/index.php?r=microservice/webapi/makeup-audio-delete",

  editMakeupAudio:
    apiRoot + "/index.php?r=microservice/webapi/edit-makeup-audio",

  thirdspread: apiRoot + "/index.php?r=datacenter/index/thirdspread",

  platformsVoices: apiRoot + "/index.php?r=anchor/webapi/platforms-voices",

  newUploadConfig: apiRoot + "/index.php?r=uploadpro/upload/config",

  newUploadcancel: apiRoot + "/index.php?r=uploadpro/upload/cancel",

  indexConfig: apiRoot + "/index.php?r=index/webapi/config",

  viewhistory: apiRoot + "/index.php?r=file/webapi/viewhistory",

  searchlog: apiRoot + "/index.php?r=scube/webapi/searchlog",

  fileList: apiRoot + "/index.php?r=file/webapi/list",

  cmstags : apiRoot + "/index.php?r=newmedia/webapi/cmstags",

  // 发起语音合成（支持多人配音）
  startSpeechTtsMulti:
    apiRoot + "/index.php?r=microservice/webapi/speech-tts-multi",
  // 主持人音色列表
  getSpeakerList: apiRoot + "/index.php?r=microservice/webapi/speaker-list",
  // 语音合成数据保存
  saveSpeechTtsMulti:
    apiRoot + "/index.php?r=microservice/webapi/speech-tts-save",
  // 语音合成获取功能列表
  getSpeechTtsFuncList:
    apiRoot + "/index.php?r=microservice/webapi/speech-function",
  // 稿件智能编辑权限
  getIntelligentEditAuth:
    apiRoot + "/index.php?r=publish/webapi/get-intelligent-edit-auth",
  // 稿件智能编辑 新建会话
  createIntelligentWriteConversation:
    apiRoot + "/index.php?r=intelligent/webapi/add-conversation",
  // 稿件智能编辑 智能问答
  askIntelligentWriter: apiRoot + "/index.php?r=intelligent/webapi/chat-submit",
  // 稿件智能编辑 获取历史对话
  getIntelligentWriterConversation:
    apiRoot + "/index.php?r=intelligent/webapi/searchlog",
  // 稿件智能编辑 获取会话详情
  getIntelligentWriterConversationDetail:
    apiRoot + "/index.php?r=intelligent/webapi/detail",
  // 稿件智能编辑 上传文件
  addfiles: apiRoot + "/index.php?r=intelligent/webapi/addfiles",
  stopIntelligentWriter: apiRoot + "/index.php?r=intelligent/webapi/stop-chat-submit",

  submitFeedback: apiRoot + "/index.php?r=index/webapi/submit-feedback",

  setPublishcover: apiRoot + "/index.php?r=publish/webapi/setcover",

  newTopicInit: apiRoot + "/index.php?r=topic/webapi/get-init",

  newTopicRelease2: apiRoot + "/index.php?r=topic/webapi/release2",

  newTopicList: apiRoot + "/index.php?r=topic/webapi/list",

  newTopicForemanConfig: apiRoot + "/index.php?r=topic/webapi/foreman-config",

  newTopicForemanOpt: apiRoot + "/index.php?r=topic/webapi/foreman-opt",

  newTopicListProgress: apiRoot + "/index.php?r=topic/webapi/list-progress",

  newTopicReleaseProgress: apiRoot + "/index.php?r=topic/webapi/release-progress",

  newTopicDeleteProgress: apiRoot + "/index.php?r=topic/webapi/delete-progress",

  newTopicListTalkarea: apiRoot + "/index.php?r=topic/webapi/list-talkarea",

  newTopicReleaseTalkarea: apiRoot + "/index.php?r=topic/webapi/release-talkarea",

  newTopicMylist: apiRoot + "/index.php?r=topic/webapi/mylist",

  newTopicVerifylist: apiRoot + "/index.php?r=topic/webapi/verifylist",

  newTopicVerify: apiRoot + "/index.php?r=topic/webapi/verify",

  newTopicRelaInterview: apiRoot + "/index.php?r=topic/webapi/rela-interview",

  newTopicDetail: apiRoot + "/index.php?r=topic/webapi/detail",

  newTopicDays: apiRoot + "/index.php?r=topic/webapi/days",

  newTopicLock: apiRoot + "/index.php?r=topic/webapi/lock",

  newTopicInterviewlist: apiRoot + "/index.php?r=topic/webapi/interviewlist ",

  newTopicPush: apiRoot + "/index.php?r=topic/webapi/push-topic-to-cube",
  
  checkNoticefile : apiRoot + "/index.php?r=content/file/check-file",

  getBiliPartition : apiRoot + "/index.php?r=newmedia/webapi/get-bili-partition",

  getTencentCate : apiRoot + "/index.php?r=newmedia/webapi/get-tencent-cate",

  getCommonPreview : apiRoot + "/index.php?r=newmedia/webapi/get-common-preview",

  getbiliurl : apiRoot + "/index.php?r=newmedia/webapi/getbiliurl",

  // 素材绑定统一内容库
  File_bind_library: apiRoot + "/index.php?r=content/file/addto",

  // 上传入口权限
  File_choose_auth: apiRoot + "/index.php?r=content/disk/file-choose-auth",

  sourceList: apiRoot + "/index.php?r=content/folder/sources",


  sourceDocList: apiRoot + "/index.php?r=content/doc/list",

  sourceDocDetail: apiRoot + "/index.php?r=content/doc/detail",

  consultBroadcastSearch: apiRoot + "/index.php?r=consult/webapi/broadcast-search", // broadcast search list

  consultLanternCarouselList: apiRoot + "/index.php?r=consult/webapi/lantern-carousel-list", // lantern carousel list

  consultLanternCarouselAddDetail: apiRoot + "/index.php?r=consult/webapi/lantern-carousel-add-detail", // lantern carousel add detail

  consultLanternCarouselWithdraw: apiRoot + "/index.php?r=consult/webapi/lantern-carousel-withdraw", // lantern carousel withdraw

  consultLanternCarouselScreenTime: apiRoot + "/index.php?r=consult/webapi/lantern-carousel-screen-time", // lantern carousel screen time

  consultLanternCarouselRetry: apiRoot + "/index.php?r=consult/webapi/lantern-carousel-retry", // lantern carousel retry

  consultLanternCarouselDetail: apiRoot + "/index.php?r=consult/webapi/lantern-carousel-detail", // lantern carousel detail

  consultLanternCarouselPush: apiRoot + "/index.php?r=consult/webapi/lantern-carousel-push", // lantern carousel push

  // 纳米资讯
  consultList: apiRoot + "/index.php?r=consult/webapi/list", // 纳米咨询上屏列表

  consultConfig: apiRoot + "/index.php?r=consult/webapi/config", // 纳米咨询上屏配置

  consultPush: apiRoot + "/index.php?r=consult/webapi/push", // 提交推送接口

  consultDetail: apiRoot + "/index.php?r=consult/webapi/detail", // 纳米咨询详情

  consultRetry: apiRoot + "/index.php?r=consult/webapi/retry", // 纳米咨询 重试

  consultWithdraw: apiRoot + "/index.php?r=consult/webapi/withdraw", // 纳米咨询 撤回

  consultUpdateScreenTime: apiRoot + "/index.php?r=consult/webapi/update-screen-time", // 纳米咨询 修改上屏时间

  consultRenTitle: apiRoot + "/index.php?r=consult/webapi/ren-title", // 纳米咨询标题格式化
};
